import { EventEmitter, SimpleChanges } from "@angular/core";
import { AccountService } from '../../../core/auth/account.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SessionService } from '../../session/session.service';
import { SessionControlComponent } from '../../session/session-chat-coach/session-control.component/session-control.component';
import { MessageService } from '../../message/message.service';
import { JhiAlertService, JhiEventManager } from '../../../ng-jhipster/service';
import { SessionStorageService } from "ngx-webstorage";
import { TranslateService } from "@ngx-translate/core";
import { CoachDetailsService } from '../../slot/coach-details.service';
import { UserOrganizationCodeService } from '../../user-organization-code/user-organization-code.service';
import { DataSharingConsentService } from '../../data-sharing-consent/data-sharing-consent.service';
import { ZoomService } from '../zoom.service';
import { TrackerService } from '../../../core/tracker/tracker.service';
import { LANGUAGES } from '../../../app.constants';
import { UserService } from '../../../core/user/user.service';
import * as i0 from "@angular/core";
import * as i1 from "../../message/message.service";
import * as i2 from "../../../ng-jhipster/service";
import * as i3 from "ngx-webstorage";
import * as i4 from "../../session/session.service";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
import * as i6 from "@ngx-translate/core";
import * as i7 from "../../../core/auth/account.service";
import * as i8 from "../../slot/coach-details.service";
import * as i9 from "../../user-organization-code/user-organization-code.service";
import * as i10 from "../../data-sharing-consent/data-sharing-consent.service";
import * as i11 from "../zoom.service";
import * as i12 from "../../../core/tracker/tracker.service";
import * as i13 from "../../../core/user/user.service";
import * as i14 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i15 from "@angular/common";
import * as i16 from "@angular/material/tooltip";
import * as i17 from "../audio-preview/audio-preview.component";
import * as i18 from "@fortawesome/angular-fontawesome";
import * as i19 from "@ctrl/ngx-emoji-mart/ngx-emoji";
import * as i20 from "../../../shared/language/find-flag-code-from-key.pipe";
function CoachSessionControlUpperMobileComponent_li_37_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 34);
    i0.ɵɵlistener("click", function CoachSessionControlUpperMobileComponent_li_37_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r10); const language_r8 = restoredCtx.$implicit; const ctx_r9 = i0.ɵɵnextContext(); const _r1 = i0.ɵɵreference(25); ctx_r9.languageChanged(language_r8); return _r1.close(); });
    i0.ɵɵelement(1, "ngx-emoji", 35);
    i0.ɵɵpipe(2, "findFlagCodeFromKey");
    i0.ɵɵelementStart(3, "span", 9);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const language_r8 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("emoji", "flag-", i0.ɵɵpipeBind1(2, 2, language_r8.code), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(language_r8.name);
} }
function CoachSessionControlUpperMobileComponent__svg_use_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 36);
} }
function CoachSessionControlUpperMobileComponent__svg_use_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 37);
} }
function CoachSessionControlUpperMobileComponent__svg_use_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 38);
} }
function CoachSessionControlUpperMobileComponent__svg_use_50_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 39);
} }
function CoachSessionControlUpperMobileComponent_div_51_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(0, "div", 40);
} }
const _c0 = function () { return { "color": "#44A38B" }; };
const _c1 = function () { return { "color": "#E1E1E1" }; };
export class CoachSessionControlUpperMobileComponent extends SessionControlComponent {
    constructor(messageService, alertService, sessionStorage, sessionService, modalService, translate, accountService, coachDetailsService, userOrganizationCodeService, dataSharingConsentService, eventManager, zoomService, trackerService, userService) {
        super(messageService, alertService, sessionStorage, sessionService, modalService, translate, accountService, coachDetailsService, trackerService);
        this.messageService = messageService;
        this.alertService = alertService;
        this.sessionStorage = sessionStorage;
        this.sessionService = sessionService;
        this.modalService = modalService;
        this.translate = translate;
        this.accountService = accountService;
        this.coachDetailsService = coachDetailsService;
        this.userOrganizationCodeService = userOrganizationCodeService;
        this.dataSharingConsentService = dataSharingConsentService;
        this.eventManager = eventManager;
        this.zoomService = zoomService;
        this.trackerService = trackerService;
        this.userService = userService;
        this.displayUserPanel = new EventEmitter();
        this.isSettingsOn = false;
        this.languageList = [
            { id: 40, code: "en", name: "English", nativeName: "English", coachReasoning: "" },
            { id: 39, code: "nl", name: "Dutch", nativeName: "Nederlands", coachReasoning: "" },
            { id: 51, code: "de", name: "German", nativeName: "Deutsch", coachReasoning: "" },
        ];
        this.hover = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.zoomService.getAvailableSpeakers().subscribe(speakers => {
            this.speakerList = speakers;
            this.selectedSpeaker = this.speakerList[0];
        });
        if (this.session != null) {
            this.userService.getCoachReasoningLanguages(this.session.coachId).subscribe(coachLanguages => {
                this.languageList = LANGUAGES.filter(lang => coachLanguages.includes(lang.code));
                this.setSelectedLanguageBasedOnSessionLanguage();
            });
        }
        else {
            console.log("Session can not be retrieved.");
        }
    }
    selectLanguage(language) {
        this.selectedLanguage = language;
    }
    toggleUserPanel() {
        this.displayUserPanel.emit();
    }
    toggleScript() {
        this.displayScriptComponent.emit();
    }
    languageChanged(language) {
        this.selectedLanguage = language;
        this.sessionService.changeSessionLanguage(this.selectedLanguage.code, this.session.id).subscribe(() => {
            this.zoomService.switchLanguage(this.selectedLanguage.code);
        });
    }
    setSelectedLanguageBasedOnSessionLanguage() {
        this.selectedLanguage = this.languageList.find(value => value.code === this.session.langKey);
    }
    ngOnChanges(changes) {
        if (changes.session && this.languageList) {
            this.setSelectedLanguageBasedOnSessionLanguage();
        }
    }
}
CoachSessionControlUpperMobileComponent.ɵfac = function CoachSessionControlUpperMobileComponent_Factory(t) { return new (t || CoachSessionControlUpperMobileComponent)(i0.ɵɵdirectiveInject(i1.MessageService), i0.ɵɵdirectiveInject(i2.JhiAlertService), i0.ɵɵdirectiveInject(i3.SessionStorageService), i0.ɵɵdirectiveInject(i4.SessionService), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i6.TranslateService), i0.ɵɵdirectiveInject(i7.AccountService), i0.ɵɵdirectiveInject(i8.CoachDetailsService), i0.ɵɵdirectiveInject(i9.UserOrganizationCodeService), i0.ɵɵdirectiveInject(i10.DataSharingConsentService), i0.ɵɵdirectiveInject(i2.JhiEventManager), i0.ɵɵdirectiveInject(i11.ZoomService), i0.ɵɵdirectiveInject(i12.TrackerService), i0.ɵɵdirectiveInject(i13.UserService)); };
CoachSessionControlUpperMobileComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CoachSessionControlUpperMobileComponent, selectors: [["coach-session-control-upper-mobile"]], inputs: { showUnreadIndicator: "showUnreadIndicator", isScriptOn: "isScriptOn", isUserPanelOn: "isUserPanelOn" }, outputs: { displayUserPanel: "displayUserPanel" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 52, vars: 37, consts: [[1, "olha-theme"], [1, "navbar"], [1, "d-flex", "align-items-center"], [1, "mr-2", "text-center"], ["jhiTranslate", "sessionChat.paragraph.timeLeft", 1, "mr-1", "time-left"], [1, "mr-1", "minutes"], ["ngbDropdown", "", 1, "d-inline-block", "text-dark", "align-middle"], ["ngbDropdownToggle", "", "href", "javascript:void(0);", 1, "language-anchor"], [1, "box-button", "box-button-dropdown", "d-flex", "align-items-center", "justify-content-center", "m-1", 3, "ngStyle", "matTooltipPosition", "matTooltipClass", "matTooltip", "mouseover", "mouseleave", "click"], [1, "m-1"], ["width", "22", "height", "22"], ["id", "actual-icon", 0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#settings"], ["ngbDropdownMenu", "", 1, "dropdown-menu", "dropdown-menu-upper-mobile", "dropdown-menu-location-primary"], ["primaryDropdown", ""], [3, "deviceId"], ["ngbDropdown", "", "placement", "auto", 1, "d-inline-block", "text-dark", "align-middle", "w-100"], ["languageDropdown", "ngbDropdown"], [1, "align-items-center", "justify-content-center", "m-1"], ["jhiTranslate", "sessionChat.coachSessionControl.transcriptionLanguage", 1, "item-bold"], [1, "d-flex", "justify-content-between", "align-items-center"], [1, "d-flex", "justify-content-start", "align-items-center"], ["width", "14", "height", "14"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#tick-mark"], [1, "item-light"], ["icon", "chevron-right", 1, "ml-2"], ["ngbDropdownMenu", "", 1, "dropdown-menu", "dropdown-menu-camera"], ["class", "item-light d-flex justify-content-start align-items-top", 3, "click", 4, "ngFor", "ngForOf"], [1, "box-button", "box-button-toggle", "d-flex", "align-items-center", "justify-content-center", "m-1", 3, "ngClass", "ngStyle", "matTooltipPosition", "matTooltipClass", "matTooltip", "click", "mouseover", "mouseleave"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#script-light", 4, "ngIf"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#script", 4, "ngIf"], [1, "position-relative", "m-1"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#panel-light", 4, "ngIf"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#panel", 4, "ngIf"], ["class", "unread-indicator", 4, "ngIf"], [1, "item-light", "d-flex", "justify-content-start", "align-items-top", 3, "click"], [3, "emoji"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#script-light"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#script"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#panel-light"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#panel"], [1, "unread-indicator"]], template: function CoachSessionControlUpperMobileComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "nav", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelement(4, "span", 4);
        i0.ɵɵelement(5, "br");
        i0.ɵɵelementStart(6, "span", 5);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 2);
        i0.ɵɵelementStart(9, "div");
        i0.ɵɵelementStart(10, "span", 6);
        i0.ɵɵelementStart(11, "a", 7);
        i0.ɵɵelementStart(12, "div", 8);
        i0.ɵɵlistener("mouseover", function CoachSessionControlUpperMobileComponent_Template_div_mouseover_12_listener() { return ctx.hover = true; })("mouseleave", function CoachSessionControlUpperMobileComponent_Template_div_mouseleave_12_listener() { return ctx.hover = false; })("click", function CoachSessionControlUpperMobileComponent_Template_div_click_12_listener() { return ctx.isSettingsOn = !ctx.isSettingsOn; });
        i0.ɵɵpipe(13, "translate");
        i0.ɵɵelementStart(14, "div", 9);
        i0.ɵɵelementStart(15, "div");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(16, "svg", 10);
        i0.ɵɵelement(17, "use", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(18, "ul", 12, 13);
        i0.ɵɵelementStart(20, "li");
        i0.ɵɵelement(21, "audio-preview", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "li");
        i0.ɵɵelementStart(23, "div");
        i0.ɵɵelementStart(24, "span", 15, 16);
        i0.ɵɵelementStart(26, "a", 7);
        i0.ɵɵelementStart(27, "div", 17);
        i0.ɵɵelement(28, "span", 18);
        i0.ɵɵelementStart(29, "div", 19);
        i0.ɵɵelementStart(30, "div", 20);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(31, "svg", 21);
        i0.ɵɵelement(32, "use", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(33, "span", 23);
        i0.ɵɵtext(34);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(35, "fa-icon", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "ul", 25);
        i0.ɵɵtemplate(37, CoachSessionControlUpperMobileComponent_li_37_Template, 5, 4, "li", 26);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 27);
        i0.ɵɵlistener("click", function CoachSessionControlUpperMobileComponent_Template_div_click_38_listener() { return ctx.toggleScript(); })("mouseover", function CoachSessionControlUpperMobileComponent_Template_div_mouseover_38_listener() { return ctx.hover = true; })("mouseleave", function CoachSessionControlUpperMobileComponent_Template_div_mouseleave_38_listener() { return ctx.hover = false; });
        i0.ɵɵpipe(39, "translate");
        i0.ɵɵelementStart(40, "div", 9);
        i0.ɵɵelementStart(41, "div");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(42, "svg", 10);
        i0.ɵɵtemplate(43, CoachSessionControlUpperMobileComponent__svg_use_43_Template, 1, 0, "use", 28);
        i0.ɵɵtemplate(44, CoachSessionControlUpperMobileComponent__svg_use_44_Template, 1, 0, "use", 29);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(45, "div", 27);
        i0.ɵɵlistener("click", function CoachSessionControlUpperMobileComponent_Template_div_click_45_listener() { return ctx.toggleUserPanel(); })("mouseover", function CoachSessionControlUpperMobileComponent_Template_div_mouseover_45_listener() { return ctx.hover = true; })("mouseleave", function CoachSessionControlUpperMobileComponent_Template_div_mouseleave_45_listener() { return ctx.hover = false; });
        i0.ɵɵpipe(46, "translate");
        i0.ɵɵelementStart(47, "div", 30);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(48, "svg", 10);
        i0.ɵɵtemplate(49, CoachSessionControlUpperMobileComponent__svg_use_49_Template, 1, 0, "use", 31);
        i0.ɵɵtemplate(50, CoachSessionControlUpperMobileComponent__svg_use_50_Template, 1, 0, "use", 32);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(51, CoachSessionControlUpperMobileComponent_div_51_Template, 1, 0, "div", 33);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(19);
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate(ctx.minutesLeft + ":" + ctx.secondsLeft);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngStyle", ctx.hover ? i0.ɵɵpureFunction0(31, _c0) : i0.ɵɵpureFunction0(32, _c1))("matTooltipPosition", "below")("matTooltipClass", "feedback-tool-tip")("matTooltip", i0.ɵɵpipeBind1(13, 25, ctx.isSettingsOn ? "sessionChat.coachSessionControl.hideSettings" : "sessionChat.coachSessionControl.showSettings"));
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("deviceId", ctx.selectedSpeaker == null ? null : ctx.selectedSpeaker.deviceId);
        i0.ɵɵadvance(13);
        i0.ɵɵtextInterpolate(ctx.selectedLanguage == null ? null : ctx.selectedLanguage.name);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("top", _r0.offsetHeight * 2 + "px");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.languageList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isScriptOn ? "box-button-toggle-active" : "")("ngStyle", ctx.hover ? i0.ɵɵpureFunction0(33, _c0) : i0.ɵɵpureFunction0(34, _c1))("matTooltipPosition", "below")("matTooltipClass", "feedback-tool-tip")("matTooltip", i0.ɵɵpipeBind1(39, 27, ctx.isScriptOn ? "sessionChat.coachSessionControl.hideScript" : "sessionChat.coachSessionControl.showScript"));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.isScriptOn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isScriptOn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isUserPanelOn ? "box-button-toggle-active" : "")("ngStyle", ctx.hover ? i0.ɵɵpureFunction0(35, _c0) : i0.ɵɵpureFunction0(36, _c1))("matTooltipPosition", "below")("matTooltipClass", "right-feedback-tool-tip")("matTooltip", i0.ɵɵpipeBind1(46, 29, ctx.isUserPanelOn ? "sessionChat.coachSessionControl.hideUserPanel" : "sessionChat.coachSessionControl.showUserPanel"));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.isUserPanelOn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isUserPanelOn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showUnreadIndicator);
    } }, directives: [i5.NgbNavbar, i14.JhiTranslateDirective, i5.NgbDropdown, i5.NgbDropdownToggle, i15.NgStyle, i16.MatTooltip, i5.NgbDropdownMenu, i17.AudioPreviewComponent, i18.FaIconComponent, i15.NgForOf, i15.NgClass, i15.NgIf, i19.EmojiComponent], pipes: [i6.TranslatePipe, i20.FindFlagCodeFromKeyPipe], styles: [".navbar[_ngcontent-%COMP%]{background:#f7eed2;padding-left:20px !important;padding-right:20px !important}.time-left[_ngcontent-%COMP%]{font-family:Poppins,sans-serif}.minutes[_ngcontent-%COMP%]{font-family:Poppins,sans-serif;font-weight:600;color:#44a38b}.box-button[_ngcontent-%COMP%]{font-family:Poppins,sans-serif;font-weight:400;width:80px;height:50px;color:#44a38b;background:#f7eed2;border-radius:8px;flex-direction:column;cursor:pointer}.box-button-toggle[_ngcontent-%COMP%]:active, .box-button-dropdown[_ngcontent-%COMP%]:hover, .box-button-toggle-active[_ngcontent-%COMP%]{color:#f7eed2;background:#44a38b}h3[_ngcontent-%COMP%]{margin-bottom:0}h5[_ngcontent-%COMP%]{margin-bottom:0}.dropdown-menu[_ngcontent-%COMP%]{padding:15px 25px;box-shadow:0 10px 20px rgba(0,0,0,.13);border:none;position:fixed;width:100% !important}.dropdown-menu-upper-mobile[_ngcontent-%COMP%]{border-radius:0 0 4px 4px}.dropdown-menu-location-primary[_ngcontent-%COMP%]{top:130px !important}.dropdown-toggle[_ngcontent-%COMP%]:after{display:none !important}a[_ngcontent-%COMP%]{text-decoration:none}.item-bold[_ngcontent-%COMP%]{margin-bottom:15px;font-family:\"Poppins\",serif;font-style:normal;font-weight:700;font-size:14px;line-height:25px;color:#0a4a3a;cursor:pointer}.item-light[_ngcontent-%COMP%]{margin-left:10px;font-family:\"Poppins\",serif;font-style:normal;font-weight:400;font-size:14px;line-height:20px;color:#44a38b;cursor:pointer;white-space:nowrap}.unread-indicator[_ngcontent-%COMP%]{background-color:var(--accent-2) !important;position:absolute;border-radius:50%;height:8px;width:8px;top:-2px;right:-3px}[_nghost-%COMP%]  .right-feedback-tool-tip{color:#fff !important;background:#44a38b !important;border:1px solid #44a38b !important;overflow:visible !important;font-size:14px !important}[_nghost-%COMP%]  .right-feedback-tool-tip:before{content:\"\";position:absolute;top:-11px;right:13px;border-bottom:10px solid #44a38b;border-left:10px solid transparent;border-right:10px solid transparent;z-index:10000}"] });
